import { getKiosks } from '@frontend/shared/kiosk/data-access/src';
import { createSelector } from '@ngrx/store';
import { getAppState } from 'apps/check-in-kiosk/src/app/reducers';
import { getWorkflows, Workflow } from '@frontend/shared/workflow/data-access';

export interface WelcomeState {
  welcomeMessage: string;
  showCheckinBtn: boolean;
  showCheckoutBtn: boolean;
  checkInWorkflows: Workflow[];
  checkOutWorkflows: Workflow[];
  implicitInId: number;
  implicitOutId: number;
}

export const getWelcomeState = createSelector(
  getKiosks,
  getWorkflows,
  getAppState,
  (kiosks: any[], workflows: any[], app: any): WelcomeState =>
    kiosks.map((kiosk) => {
      const checkInWorkflows = workflows.filter(
        (w) => kiosk.checkin_workflow_ids.indexOf(w.id) !== -1
      );
      const checkOutWorkflows = workflows.filter(
        (w) => kiosk.checkout_workflow_ids.indexOf(w.id) !== -1
      );
      const implicitInId =
        checkInWorkflows.length === 1 &&
        checkInWorkflows
          .slice(0, 1)
          .map((w) => w.id)
          .shift();
      const implicitOutId =
        checkOutWorkflows.length === 1 &&
        checkOutWorkflows
          .slice(0, 1)
          .map((w) => w.id)
          .shift();
      return {
        welcomeMessage: app.localeId === 'es' ? null : kiosk.welcome_message,
        checkInWorkflows,
        checkOutWorkflows,
        showCheckinBtn: checkInWorkflows.length > 1,
        showCheckoutBtn: checkOutWorkflows.length > 1,
        implicitInId,
        implicitOutId,
      };
    })[0]
);
